import _ from 'lodash';

export class Person {

	get fullName() {
		if(this.firstName || this.lastName){
			return `${this.firstName || ''} ${this.lastName || ''}`;
		}
		return this.username;
	}

	get name() {
		return this.fullName || this.email || 'Unknown';
	}

	static fromJSON(json) {
		return _.extend(new this(), {
			firstName: json.first_name,
			lastName: json.last_name,
			email: json.email,
			username: json.username,
			googleAccountId: json.google_account_id,
			id: json.id
		});
	}
}

export class PagedResponse {

	static fromJSON(json, ItemClass) {
		const base = {
			page: json.current_page,
			items: _.map(json.items, ItemClass.fromJSON.bind(ItemClass)),
			itemsCount: json.items_count,
			totalPages: json.max_page,
			sorts: json.sorts
		};
		if (_.isNumber(json.max_watch)) {
			base.watching = json.watching;
			base.maxWatch = json.max_watch;
		}
		if (_.isArray(json.columns)) {
			base.columns = json.columns;
		}
		if (!_.isUndefined(json.filters)) {
			base.filters = json.filters;
		}
		if (!_.isUndefined(json.sorts)) {
			base.sorts = json.sorts;
		}
		if (!_.isUndefined(json.totals)) {
			base.totals = json.totals;
		}
		return _.extend(new this(), base);
	}

}

export class Country {

	static fromJSON(json) {
		return _.extend(new this(), {
			code: json.id,
			common: json.common,
			official: json.official,
			id: json.id,
			title: json.common,
			pk: json.pk
		});
	}

}
